import { render, staticRenderFns } from "./payment-methods.vue?vue&type=template&id=bd37e428&scoped=true&"
import script from "./payment-methods.vue?vue&type=script&lang=js&"
export * from "./payment-methods.vue?vue&type=script&lang=js&"
import style0 from "./payment-methods.vue?vue&type=style&index=0&id=bd37e428&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd37e428",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default,DrawerHeader: require('/app/components/drawer/components/drawerHeader.vue').default})
